import { Navigate } from 'react-router-dom';
import { useGetSettingMenu } from 'src/api/menu_api';
import { PATHS } from 'src/routes/paths';
import { getFirstSettingsRoute } from 'src/sections/settings/settings_menu';

export default function SettingsIndexRedirect() {
  const { searchResults, isSettingAccess, searchLoading } = useGetSettingMenu();

  if (searchLoading) {
    return null;
  }

  const firstRoute = isSettingAccess ? getFirstSettingsRoute(searchResults) : null;

  return (
    <Navigate
      to={firstRoute ?? PATHS.dashboard.root}
      replace
    />
  );
}
